var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46154 17.687V13.8681H4.15385C3.84783 13.8681 3.55434 13.7292 3.33795 13.4819C3.12157 13.2346 3 12.8992 3 12.5495V3.31868C3 2.96895 3.12157 2.63353 3.33795 2.38623C3.55434 2.13893 3.84783 2 4.15385 2H16.8462C17.1522 2 17.4457 2.13893 17.662 2.38623C17.8784 2.63353 18 2.96895 18 3.31868V12.5495C18 12.8992 17.8784 13.2346 17.662 13.4819C17.4457 13.7292 17.1522 13.8681 16.8462 13.8681H10.5L6.95423 17.9204C6.91389 17.9667 6.86244 17.9982 6.80642 18.0109C6.75039 18.0237 6.69231 18.0172 6.63954 17.9922C6.58677 17.9672 6.54168 17.9248 6.50999 17.8705C6.4783 17.8162 6.46144 17.7523 6.46154 17.687Z",
    stroke: "#667185",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 9.91112H14.5379M6.46094 5.95508H14.5379",
    stroke: "#667185",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInactive);
export default __webpack_public_path__ + "static/media/message-inactive.12c6427b4789d4046ef05a0dd9be9452.svg";
export { ForwardRef as ReactComponent };